import { SkillEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import { range } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { QuestionNumberButton } from '@doltech/ui/lib/figma/Question/QuestionNumberButton/QuestionNumberButton';
import { flexGap } from '@doltech/utils/lib/css-style';
import cl from 'classnames';
import { useTestResultStore } from '../model/test-result.hook';

interface QuestionPalletesProps extends React.HTMLAttributes<HTMLDivElement> {
  customStore?: any;
  onHide?: () => void;
}

const QuestionSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${flexGap([8, 8])}
`;

const TestSectionHeader = styled.h6`
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
`;

const TestSection = styled.section`
  flex: 1;
`;

const Main = styled.div`
  &.fullTest {
    display: grid;
    gap: 12px;

    ${fromScreen(1280)} {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: minmax(0px, 244px);
      gap: 24px;
    }
  }
`;

const questionStatusMapper = {
  WRONG: 'wrong',
  CORRECT: 'correct',
  MISSING: 'missed',
};

export const QuestionPalletes = observer((props: QuestionPalletesProps) => {
  const { customStore, onHide } = props;
  const { className } = props;
  const store = useTestResultStore() || customStore;
  const isFullTest = store.testType === TestTypeEnum.FULL_TEST;
  return (
    <Main className={cl(className, { fullTest: isFullTest })}>
      {store.testSections.map((testSection, index) => {
        const { id, skill } = testSection;
        let testSectionHeader = 'Passage';
        if (skill === SkillEnum.LISTENING) {
          testSectionHeader = 'Section';
        }

        const questions = testSection.getQuestions();
        return (
          <TestSection key={id} className="question-test-section">
            {isFullTest && (
              <TestSectionHeader className="question-test-section-header">
                {testSectionHeader} {index + 1}
              </TestSectionHeader>
            )}
            <QuestionSection>
              {questions.map((question) => {
                const { no, markedStatus, questionCount, scroll } = question;

                return range(questionCount || 1).map((questionIndex) => {
                  return (
                    <QuestionNumberButton
                      key={no}
                      type={questionStatusMapper[markedStatus] || 'default'}
                      size={isFullTest ? 'small' : 'large'}
                      textNumber={no}
                      selected={store.currentQuestionIndex === no + questionIndex - 1}
                      onClick={() => {
                        if (store.preventUserAction()) return;
                        store.goToQuestion(no, scroll);
                        onHide?.();
                      }}
                    />
                  );
                });
              })}
            </QuestionSection>
          </TestSection>
        );
      })}
    </Main>
  );
});
